var map = {
	"./Amex.svg": 1244,
	"./Apple.svg": 1245,
	"./Arrow-Coverage-Dark.svg": 1246,
	"./Arrow-Coverage-Light.svg": 1247,
	"./Arrow-Coverage.svg": 1248,
	"./Arrow-Element.svg": 1249,
	"./Arrow-Macro-Light.svg": 1250,
	"./Arrow-Macro.svg": 1251,
	"./Arrow-Micro-Dark.svg": 1252,
	"./Arrow-Micro.svg": 1253,
	"./Auth.svg": 1254,
	"./Close-Dark.svg": 1255,
	"./Close-Light.svg": 1256,
	"./Coverage-Dark.svg": 1257,
	"./Coverage-Light.svg": 1258,
	"./Credit-Card.svg": 1259,
	"./Data-Dark-16.svg": 1260,
	"./Data-Dark.svg": 1261,
	"./Data-Light-16.svg": 1262,
	"./Data-Light.svg": 1263,
	"./Down-Arrow.svg": 1264,
	"./Facebook-Original.svg": 1265,
	"./Footer-Amex.svg": 1266,
	"./Footer-Arrow-Close.svg": 1267,
	"./Footer-Arrow-Open.svg": 1268,
	"./Footer-Facebook.svg": 1269,
	"./Footer-Instagram.svg": 1270,
	"./Footer-Linkedin.svg": 1271,
	"./Footer-MasterCard.svg": 1272,
	"./Footer-Paypal.svg": 1273,
	"./Footer-Twitter.svg": 1274,
	"./Footer-VK.svg": 1275,
	"./Footer-Visa.svg": 1276,
	"./Footer-X.svg": 1277,
	"./GooglePlayStore.svg": 1278,
	"./ID.svg": 1279,
	"./Information.svg": 1280,
	"./Inline-American-Express.svg": 1281,
	"./Inline-MasterCard.svg": 1282,
	"./Inline-Unionpay.svg": 1283,
	"./Inline-Visa.svg": 1284,
	"./Input-Search-Dark.svg": 1285,
	"./Input-Search-Light.svg": 1286,
	"./Linkedin-Light.svg": 1287,
	"./Log-out-red.svg": 1288,
	"./Log-out.svg": 1289,
	"./Logo.svg": 1290,
	"./Manual-Install.svg": 1291,
	"./Mastercard.svg": 1292,
	"./PayPal.svg": 1293,
	"./Plus.svg": 1294,
	"./Price-Dark.svg": 1295,
	"./Price-Light.svg": 1296,
	"./QR.svg": 1297,
	"./Readonly-Input-Lock.svg": 1298,
	"./Saved-Amex.svg": 1299,
	"./Saved-MasterCard.svg": 1300,
	"./Saved-Visa.svg": 1301,
	"./Search.svg": 1302,
	"./Secure-Auth.svg": 1303,
	"./Secure-W.svg": 1304,
	"./Secure.svg": 1305,
	"./Share.svg": 1306,
	"./Star_color.svg": 1307,
	"./Store-Active-Dark.svg": 1308,
	"./Store-Active-Light.svg": 1309,
	"./Store-B.svg": 1310,
	"./Store-Inactive.svg": 1311,
	"./Store-W.svg": 1312,
	"./Store.svg": 1313,
	"./Success.svg": 1314,
	"./Trash.svg": 1315,
	"./Twitter-Original.svg": 1316,
	"./User-Active-Dark.svg": 1317,
	"./User-Active-Light.svg": 1318,
	"./User-Inactive.svg": 1319,
	"./Validity-Dark.svg": 1320,
	"./Validity-Light.svg": 1321,
	"./Visa.svg": 1322,
	"./What-is-This.svg": 1323,
	"./copy.svg": 1324,
	"./eSIM-Active-Dark.svg": 1325,
	"./eSIM-Active-Light.svg": 1326,
	"./eSIM-Dark.svg": 1327,
	"./eSIM-Inactive.svg": 1328,
	"./eSIM-Light.svg": 1329,
	"./email.svg": 1330,
	"./facebook.svg": 1331,
	"./ic_add-card.svg": 1332,
	"./ic_airmoney_macro.svg": 861,
	"./ic_airmoney_micro.svg": 1333,
	"./ic_airmoney_pay.svg": 1334,
	"./ic_airmoney_payment-method.svg": 1335,
	"./ic_alipay_payment-method-dark.svg": 1336,
	"./ic_alipay_payment-method-light.svg": 1337,
	"./ic_amex.svg": 1338,
	"./ic_apple-dark.svg": 1339,
	"./ic_apple-light.svg": 1340,
	"./ic_apple-pay_payment-method.svg": 1341,
	"./ic_arrow_slider_active_Light.svg": 1342,
	"./ic_arrow_slider_inactive_Light.svg": 1343,
	"./ic_back_header-dark.svg": 1344,
	"./ic_back_header-light.svg": 1345,
	"./ic_banner_refeere.svg": 1346,
	"./ic_banner_referrer.svg": 1347,
	"./ic_bill_to_org_payment-method-light.svg": 1348,
	"./ic_calls.svg": 1349,
	"./ic_checkbox_active.svg": 1350,
	"./ic_checkbox_inactive.svg": 1351,
	"./ic_chevron-right.svg": 1352,
	"./ic_chip.svg": 1353,
	"./ic_clear.svg": 1354,
	"./ic_close_white.svg": 1355,
	"./ic_copy.svg": 1356,
	"./ic_coverage.svg": 1357,
	"./ic_credit-card_payment-method-dark.svg": 1358,
	"./ic_credit-card_payment-method-light.svg": 1359,
	"./ic_data.svg": 1360,
	"./ic_delete_white.svg": 1361,
	"./ic_discount-code.svg": 1362,
	"./ic_edit_white.svg": 1363,
	"./ic_esim.svg": 1364,
	"./ic_expire.svg": 1365,
	"./ic_fup.svg": 1366,
	"./ic_google-pay.svg": 1367,
	"./ic_google-pay_payment-method.svg": 1368,
	"./ic_google.svg": 1369,
	"./ic_help_center.svg": 1370,
	"./ic_install.svg": 1371,
	"./ic_jcb.svg": 1372,
	"./ic_logout.svg": 1373,
	"./ic_long-back-arrow.svg": 1374,
	"./ic_manual_install.svg": 1375,
	"./ic_mastercard.svg": 1376,
	"./ic_notification.svg": 1377,
	"./ic_package.svg": 1378,
	"./ic_paypal_payment-method-dark.svg": 1379,
	"./ic_paypal_payment-method-light.svg": 1380,
	"./ic_play.svg": 1381,
	"./ic_price.svg": 1382,
	"./ic_price_v2.svg": 862,
	"./ic_qrcode_install.svg": 1383,
	"./ic_routing.svg": 1384,
	"./ic_screenshot.svg": 1385,
	"./ic_sms.svg": 1386,
	"./ic_statistic.svg": 1387,
	"./ic_store_header.svg": 1388,
	"./ic_stripe.svg": 1389,
	"./ic_subscription.svg": 1390,
	"./ic_success.svg": 1391,
	"./ic_success_banner.svg": 1392,
	"./ic_success_order-completed.svg": 1393,
	"./ic_telegram.svg": 1394,
	"./ic_tips.svg": 1395,
	"./ic_unionpay.svg": 1396,
	"./ic_validity.svg": 1397,
	"./ic_visa.svg": 1398,
	"./ic_visa_payment-method.svg": 1399,
	"./ic_visa_saved-card.svg": 1400,
	"./ic_whatsapp.svg": 1401,
	"./icon-ekyc-detail-card-info.svg": 1402,
	"./icon-ekyc-detail-driver-license.svg": 1403,
	"./icon-ekyc-detail-faq-arrow.svg": 1404,
	"./icon-ekyc-detail-finger-print.svg": 1405,
	"./icon-ekyc-detail-identity-card.svg": 1406,
	"./icon-ekyc-detail-jumio.svg": 1407,
	"./icon-ekyc-detail-passport.svg": 1408,
	"./icon-esim-detail-copy-dark.svg": 1409,
	"./icon-esim-detail-copy-light.svg": 1410,
	"./icon-esim-detail-coverage-arrow-dark.svg": 1411,
	"./icon-esim-detail-coverage-arrow-light.svg": 1412,
	"./icon-esim-detail-error-text-field-dark.svg": 1413,
	"./icon-esim-detail-error-text-field-light.svg": 1414,
	"./icon-header-airmoney.svg": 1415,
	"./icon-header-arrow-close.svg": 1416,
	"./icon-header-language.svg": 1417,
	"./icon-header-myesim.svg": 1418,
	"./icon-header-profile.svg": 1419,
	"./icon-header-store.svg": 1420,
	"./icon-hero-rating-appstore.svg": 1421,
	"./icon-hero-rating-googleplay.svg": 1422,
	"./icon-homepage-country-arrow-close.svg": 1423,
	"./icon-homepage-country-arrow-open.svg": 1424,
	"./icon-homepage-country-data-dark-16.svg": 1425,
	"./icon-homepage-country-data-dark-22.svg": 1426,
	"./icon-homepage-country-data-light-16.svg": 1427,
	"./icon-homepage-country-data-light-22.svg": 1428,
	"./icon-info-general-dark.svg": 1429,
	"./icon-info-general-light.svg": 1430,
	"./icon-mob-website-expansion-item-arrow.svg": 1431,
	"./icon-myesims-checklist.svg": 1432,
	"./icon-myesims-nosign.svg": 1433,
	"./icon-myesims-trash-slash.svg": 1434,
	"./icon-myesims-wifi-exclamationmark.svg": 1435,
	"./icon-orders-billed-to.svg": 1436,
	"./icon-package-3g-light.svg": 1437,
	"./icon-package-4g-light.svg": 1438,
	"./icon-package-5g-light.svg": 1439,
	"./icon-package-activation-policy-light.svg": 1440,
	"./icon-package-arrow-general-light.svg": 1441,
	"./icon-package-calling-credit-light.svg": 1442,
	"./icon-package-coverage-dark.svg": 1443,
	"./icon-package-coverage-light.svg": 1444,
	"./icon-package-ekyc-micro-light.svg": 1445,
	"./icon-package-ekyc-restriction-light.svg": 1446,
	"./icon-package-ekyc-validation-light.svg": 1447,
	"./icon-package-fup-dark.svg": 1448,
	"./icon-package-fup-light.svg": 1449,
	"./icon-package-info-general-light.svg": 1450,
	"./icon-package-lte-light.svg": 1451,
	"./icon-package-network-light.svg": 1452,
	"./icon-package-plan-type-light.svg": 1453,
	"./icon-package-price-dark.svg": 1454,
	"./icon-package-price-light.svg": 1455,
	"./icon-package-supported-arrow-dark.svg": 1456,
	"./icon-package-supported-arrow-light.svg": 1457,
	"./icon-package-topup-option-light.svg": 1458,
	"./icon-package-validity-dark.svg": 1459,
	"./icon-package-validity-light.svg": 1460,
	"./icon-partner-with-us-breadcrumb-arrow.svg": 1461,
	"./icon-password-hidden-error.svg": 1462,
	"./icon-password-hidden.svg": 1463,
	"./icon-password-visible-error.svg": 1464,
	"./icon-password-visible.svg": 1465,
	"./icon-search-clear.svg": 1466,
	"./icon-search.svg": 1467,
	"./icon-unlimited-dark.svg": 1468,
	"./icon-unlimited-light.svg": 1469,
	"./icon-website-expansion-content-box-bg-sm.svg": 1470,
	"./icon-website-expansion-content-box-bg.svg": 1471,
	"./mail.svg": 1472,
	"./order-async/my-esims/top-up-is-delayed.svg": 1473,
	"./order-async/my-esims/top-up-is-failed.svg": 1474,
	"./order-async/my-esims/top-up-is-on-the-way.svg": 1475,
	"./settings_button.svg": 1476,
	"./tabs-Airmoney.svg": 1477,
	"./tabs-Credit-Card.svg": 1478,
	"./tabs-PayPal.svg": 1479,
	"./telegram.svg": 1480,
	"./tick-light.svg": 1481,
	"./twitter.svg": 1482,
	"./whatsapp.svg": 1483
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 858;